var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mcm-card',{ref:"ref",attrs:{"loading":_vm.loading,"title":_vm.title,"subtitle":_vm.subtitle,"error":_vm.error},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_vm._t("buttons")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }